export default "__VITE_PUBLIC_ASSET__6ec26469__"